import styled from 'styled-components';
import theme from 'styles/theme';

export const ChannelDetailsWrapper = styled.div.attrs({
  className: 'container',
})`
  ol > li.active > span:last-child {
    font-weight: bold;
    color: ${theme.colors.dark};
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;
